import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListItemWrapper = styled.div`
  padding: 0;
`;

export const DocWrapper = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  word-break: break-word;
  min-width: 0;

  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.black9};

  i {
    padding: 12px;
    font-size: 22px;
  }
`;

export const LinkWrapper = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  word-break: break-word;
  min-width: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.black9};

  i {
    padding: 12px;
    font-size: 22px;
  }
`;

export const LinkType = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const TitleWrapper = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const IconWrapper = styled.div<{ $background: string }>`
  background: ${({ $background }) => $background} !important;
  border-radius: 4px;
  padding: 6px;
`;

export const Text = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
